import React from 'react'

export default function Loading() {
    return (
        <div style={{height: '100vh', background: 'black', width: '100vw'}}>
            <h1>Loading</h1>
        </div>
    )
}
